<script>
import AppMenu from './components/AppMenu'
import Err from './components/error'
import UserActions from './components/UserActions'

export default {
	name: 'app',
	components: {
		AppMenu,
		UserActions,
		Err
	},
	computed: {
		app () {
			return this.$store.state.app
		},
		loading () {
			return this.$store.state.app.loading && !this.$store.state.app.suppressLoading
		}
	}
}
</script>

<template>
  <div id="app">
    <div class="header bg-blue-grey">
      <span class="logo"><img src="./assets/schoox_logo.png" /></span>
      <UserActions></UserActions>
      <h2 class="color-light-green">{{app.title}} <span class="version">v{{app.version}}</span></h2>
    </div>
    <AppMenu></AppMenu>
    <Err></Err>

    <div class="app-body">
      <loading-bar v-if="loading"></loading-bar>
      <router-view></router-view>
    </div>

  </div>
</template>

<style>
html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
*, *:before, *:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
}

.header{
  -webkit-box-shadow: 3px 3px 8px 0 rgba(0,0,0,.15);
  -moz-box-shadow: 3px 3px 8px 0 rgba(0,0,0,.15);
  box-shadow: 3px 3px 8px 0 rgba(0,0,0,.15);
  border-bottom: solid 1px #868f93;
  padding: 0.5rem 0.75rem;
  min-height: 60px;
}
.header h2{
  margin: 0;
  margin-top: 8px;
  font-size: 30px;
}
.logo{
  float:left;
}
.app-body{
  padding: 0 1rem;
  margin: 0;
}
.version{
  font-size: 0.6em;
}
</style>


// WEBPACK FOOTER //
// App.vue?6ba46548